export const SET_AKAMAI_LOC_ZIPCODE = 'SET_AKAMAI_LOC_ZIPCODE';
export const AKAMAI_LOC_ZIPCODE_SUCCESS = 'AKAMAI_LOC_ZIPCODE_SUCCESS';
export const AKAMAI_LOC_ZIPCODE_ERROR = 'AKAMAI_LOC_ZIPCODE_ERROR';
export const AKAMAI_LOC_ZIPCODE_INITIATE = 'AKAMAI_LOC_ZIPCODE_INITIATE';
